module.exports = __webpack_public_path__ + "statics/img/activationCode.fc64f556.svg";